<template>
  <Flex
    direction="column"
    :class="$style.base"
  >
    <BaseText bold>
      {{ $t(`marketing.insights.tips.${tip}.title`) }}
    </BaseText>
    <BaseText>
      {{ $t(`marketing.insights.tips.${tip}.description`) }}
    </BaseText>
    <Flex
      align="center"
      :class="$style.linkSpace"
    >
      <BaseText
        :href="helpCenterArticleUrl($t(`marketing.insights.tips.${tip}.link`))"
      >
        {{ $t('global.learn_more') }}
      </BaseText>
      <BaseText
        v-if="videoId && isTrial && language === 'nl'"
        iconBefore="play-circle"
        :href="`https://vimeo.com/${videoId}`"
        target="_blank"
      >
        {{ $t('global.watch_video') }}
      </BaseText>
    </Flex>
    <img
      :class="$style.image"
      :src="`/img/insights/tips/${tip}.svg`"
    >
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { helpCenterArticleUrl } from '@/helpers/help-center';
import { useCompanyStore } from '@/stores/company';
import { useLocalizationStore } from '@/stores/localization';

const { isTrial, company } = useCompanyStore();
const { language } = useLocalizationStore();

interface TipProps {
  tip: string;
  videoId?: string;
}

defineProps<TipProps>();
</script>

<style
  lang="scss"
  module
>
.base {
  position: relative;
  padding: $spacing;
  border-radius: $radius;
  overflow: hidden;
  background: var(--surface-primary);
  border: 1px solid var(--border);
}

.linkSpace {
  margin-top: $spacing * 6;
}

.image {
  width: 130px;
  position: absolute;
  bottom: -14px;
  right: -4px;
}
</style>
